import { createScheduleSearchIndex } from '~/features/Schedule/search.js';

export const scheduleSearchIndex = createScheduleSearchIndex();
